import React from 'react';
import { routing } from '@utils/routing';
import { thumbnails } from '../../assets/thumbnails';
import { AppsIntegrationUnified } from '../AppsIntegrationUnified';
import { AppsMailchimpSettings } from './AppsMailchimpSettings';
export const AppsMailchimp = () => {
    return (React.createElement(AppsIntegrationUnified, { appId: "mailchimp", name: "Mailchimp", logoSrc: thumbnails.mailchimpThumbnail, connectDescription: "Connect to your Mailchimp account.", longDescription: "Use Mailchimp to sync supporter emails and send custom emails.", helpCenterUrl: routing.external.helpCenter.mailchimp },
        React.createElement(AppsMailchimpSettings, null)));
};
